import React, { useState } from 'react';
import DarkModeToggle from '../components/DarkModeToggle';
import Button from '../components/Button';
import Input from '../components/Input';
import { EnvelopeIcon, CheckCircleIcon, LockClosedIcon, MagnifyingGlassIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

const Dashboard = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-semibold">Dashboard</h1>
        <DarkModeToggle />
      </div>

      <div>
      <Button
        icon={PlusIcon}
        variant="primary"
        size="md"
        onClick={() => console.log('Add clicked')}
        >
        Add Item
        </Button>

        <Button
        icon={TrashIcon}
        variant="danger"
        size="sm"
        onClick={() => console.log('Delete clicked')}
        >
        Delete
        </Button>

        <Button href="https://example.com" variant="outline" size="lg">
            Visit Site
            </Button>

        <Button
            icon={TrashIcon}
            iconOnly
            tooltip="Delete item"
            tooltipPlacement="left"
            variant="danger"
            size="sm"
            onClick={() => console.log('deleted')}
            />

        <Button
            variant="primary"
            size="md"
            fullWidth
            onClick={() => alert('Full-width clicked')}
            isLoading
            loadingText="Submitting..."
            >
            Submit Form
            </Button>
      </div>

      <div>
      <Input
  name="username"
  label="Username"
  placeholder="johndoe"
/>

<Input
  name="email"
  type="email"
  label="Email"
  leadingIcon={<EnvelopeIcon />}
  placeholder="you@example.com"
/>

<Input
  name="price"
  type="number"
  label="Price"
  trailingAddOn="USD"
  placeholder="0.00"
/>

<Input
  name="website"
  label="Website"
  leadingAddOn="https://"
  placeholder="example.com"
  error="Please enter a valid URL"
/>

<Input
  name="api-key"
  label="API Key"
  value="sk_test_1234567890"
  disabled
  helpText="Contact support to change your API key"
/>

<Input
  id="email"
  label="Email address"
  type="email"
  placeholder="you@example.com"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  leftIcon={<EnvelopeIcon className="h-4 w-4" />}
  rightIcon={<CheckCircleIcon className="h-4 w-4 text-green-500" />}
  inputGroupLeft="@"
  info="We'll never share your email."
  note="Use your company email if available."
  error="Enter valid email"
/>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 className="text-lg font-bold mb-2">Users</h2>
          <p>102 Registered</p>
        </div>

        <div className="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 className="text-lg font-bold mb-2">Revenue</h2>
          <p>$5,200</p>
        </div>

        <div className="bg-white dark:bg-gray-800 p-4 rounded shadow">
          <h2 className="text-lg font-bold mb-2">Pending Tasks</h2>
          <p>7 tasks to complete</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
